import pxToRem from "../../../assets/theme/functions/pxToRem";
import {popoverActionsIcon} from "../../../components/PopoverActionsIcon";
import {Box} from "@mui/material";
import logo from "../../../assets/icons/dolovo-D.png";
import MDTypography from "../../../components/MDTypography";
import {truncate} from "../../../services/helpers";


export const dataTableModel = {
  columns: [
    {Header: "Name", accessor: "name"},
    {Header: "Category", accessor: "category__name"},
    {Header: "Logo", accessor: "logo_row", disableOrdering: true},
    {Header: "Address", accessor: "address"},
    {Header: "Supply Managers", accessor: "supply_managers_names", disableOrdering: true},
    {Header: "Primary Supplier", accessor: "primary_supplier_row", disableOrdering: true},
    {Header: "", accessor: "actions", align: "left", disableOrdering: true, width: pxToRem(5)}
  ],
  rows: [],
};

export const renderBrandLogo = (item) => {
  return (
    <Box display={"flex"} alignItems={"center"} gap={1}>
      <Box display={"flex"} alignItems={"center"} sx={{background:"#fff"}} borderRadius={'50%'}>
      { item.logo
        ? <Box component={"img"} src={item.logo} alt={"logo"} width={pxToRem(50)}  height={pxToRem(50)} borderRadius={"50%"} sx={{objectFit: 'contain'}} />
        : <Box component={"img"} src={logo} alt={"logo"} width={pxToRem(50)} height={pxToRem(50)} borderRadius={"50%"}  />
      }
      </Box>
    </Box>
  )
}


export const renderPrimarySupplier = (item) => {
  if (!item.primary_supply_manager_name) {
    return (
      <MDTypography variant={"caption"} color={"text"} fontWeight={"regular"}>
        Not set
      </MDTypography>
    )
  }
  const ready = item.primary_supply_manager_stripe_ready
  return (
    <Box display={"flex"} flexDirection={"column"}>
      <MDTypography variant={"button"} fontWeight={"medium"}>
        {item.primary_supply_manager_name}
      </MDTypography>
      <MDTypography variant={"caption"} fontWeight={"medium"} color={ready ? "success" : "error"}>
        {ready ? "Stripe connected" : "Stripe not connected"}
      </MDTypography>
    </Box>
  )
}

export const renderTableRow = (item, setAnchorEl, setOpenPopover, setSelectedItem) => {
  item.logo_row = renderBrandLogo(item)
  item.supply_managers_names = truncate(item.supply_managers_names, 30)
  item.primary_supplier_row = renderPrimarySupplier(item)
  item.actions = (popoverActionsIcon(item, setAnchorEl, setOpenPopover, setSelectedItem))
  item.category__name = item.category_name
  return item
}
